// Hidden unless display-mode is window-controls-overlay; see styles/globals.css.
const TitleBar = () => {
	return (
		<div className='titlebar'>
			<span>nina</span>
		</div>
	)
}

export { TitleBar }
